import { CSSProperties } from "react";

import type { BubblePosition } from "../types";
import { getMorphOrigin } from "./get_morph_origin";

type MorphStyleParams = {
  isOpen: boolean;
  bubbleSize: number;
  panelSize: { width: number; height: number };
  position: BubblePosition;
  triggerZIndex: number;
  panelZIndex: number;
};

export const getMorphStyle = ({
  isOpen,
  bubbleSize,
  panelSize,
  position,
  triggerZIndex,
  panelZIndex
}: MorphStyleParams): CSSProperties =>
  isOpen
    ? {
        width: panelSize.width,
        height: panelSize.height,
        borderRadius: "var(--radiusMd)",
        transformOrigin: getMorphOrigin(position),
        overflow: "hidden",
        zIndex: panelZIndex
      }
    : {
        width: bubbleSize,
        height: bubbleSize,
        borderRadius: bubbleSize / 2,
        transformOrigin: getMorphOrigin(position),
        zIndex: triggerZIndex
      };
